import { render, staticRenderFns } from "./LightSenceView.vue?vue&type=template&id=21f11dd7&"
import script from "./LightSenceView.vue?vue&type=script&lang=ts&"
export * from "./LightSenceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports